import { Button, Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UserCardType } from '~/types/paymentTypes';
import { useGetUserCardsQuery } from '~/redux/api/userApiSlice';
import { useGetUserSubscriptionQuery } from '~/redux/api/subscriptionApiSlice';
import PageLayout from '~myAccount/components/PageLayout';
import ListLoader from '~/components/ListLoader';
import SubscriptionDetails from '~myAccount/pages/UserSubscription/SubscriptionDetails';
import PaymentDetails from '~myAccount/pages/UserSubscription/PaymentDetails';
import { useFullRoutes } from '~/hooks';
import { sendGTMEvent } from '~/utils';
import { AqarmapProSourceEnum } from '~/constants/enums';

const UserSubscription = () => {
  const { t, i18n } = useTranslation('app');
  const { SUBSCRIPTION_URL } = useFullRoutes();
  const locale = i18n.language;
  const navigate = useNavigate();
  const { data: subscription, isLoading: isSubscriptionLoading } =
    useGetUserSubscriptionQuery({
      locale,
    });

  const { data: cardsResponse } = useGetUserCardsQuery();
  const cards: UserCardType[] = cardsResponse?.data;

  return (
    <PageLayout
      bodyClassName="border border-gray rounded-[8px]"
      title={t('subscriptionPlan')}
      ctas={
        subscription ? (
          <button
            className="text-link text-blue px-3x py-x "
            onClick={() => {
              sendGTMEvent({
                event: 'gtm-aqarmap_pro',
                subscribe_source: AqarmapProSourceEnum.MY_ACCOUNT,
              });
              window.location.href = SUBSCRIPTION_URL.ROOT;
            }}
          >
            {t('changePlan')}
          </button>
        ) : null
      }
    >
      {isSubscriptionLoading ? (
        <div className="p-3x ">
          <ListLoader height={24} count={5} />
        </div>
      ) : !subscription ? (
        <div className="flex flex-col gap-2x items-center p-2x md:p-4x  h-full md:h-auto">
          <Icon name="premium" size="80" className="text-gray__dark_1" />
          <p className="text-title_4 text-gray__dark_2 text-center">
            {t('noSubscriptionsFound')}
          </p>
          <Button
            variant="primary"
            size="large"
            className="w-full md:w-[343px]"
            onClick={() => navigate(SUBSCRIPTION_URL.ROOT)}
          >
            {t('subscribeNow')}
          </Button>
        </div>
      ) : (
        <div className="flex flex-col gap-2x py-3x ">
          <SubscriptionDetails {...subscription} />
          {cards?.length > 0 && (
            <PaymentDetails card={cards[cards.length - 1]} />
          )}
        </div>
      )}
    </PageLayout>
  );
};

export default UserSubscription;
